'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_MODEL = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _class, _class2, _temp; /*
                            |-------------------------------------------------------------------------------
                            | Select Container
                            |-------------------------------------------------------------------------------
                            |
                            | The following component has the role of a an state and action container.
                            | It manages state that is required by all controllers inside of a Select,
                            | along with a set of actions for each state.
                            |
                            | State:
                            |  - optionsAll
                            |  - multi
                            |  - isLoading
                            |  - options
                            |  - value
                            |  - selected
                            |  - index
                            |  - isOpen
                            |
                            | Actions
                            |  - setValue
                            |  - clearValue
                            |  - pushIndexedToSelected
                            |  - pushSelected
                            |  - popSelected
                            |  - clearSelected
                            |  - openMenu
                            |  - closeMenu
                            |  - setIndex
                            |  - incrementIndex
                            |  - decrementIndex
                            |
                            | Helpers:
                            |  - pluckLabel
                            |  - pluckValue
                            |
                            */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _coreDecorators = require('core-decorators');

var _styling = require('@rexlabs/styling');

var _customPropTypes = require('../utils/custom-prop-types');

var _defaultFilter = require('../utils/default-filter');

var _defaultFilter2 = _interopRequireDefault(_defaultFilter);

var _batch = require('../utils/batch');

var _batch2 = _interopRequireDefault(_batch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECT_MODEL = exports.SELECT_MODEL = '@@rexlabs-select-model';

/*
|-------------------------------------------------------------------------------
| Container
|-------------------------------------------------------------------------------
*/
// eslint-disable-next-line react/prop-types
var Container = function Container(_ref) {
  var styles = _ref.styles,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles']);
  return _react2.default.createElement('div', (0, _extends3.default)({}, props, styles.with('container')(props)));
};
Container.defaultProps = { style: {} };
var StyledContainer = (0, _styling.styled)()(Container);

function createDumbEvent() {
  var event = { defaultPrevented: false };
  event.preventDefault = function preventDefault() {
    event.defaultPrevented = true;
  };
  event.stopPropagation = function stopPropagation() {};
  return event;
}

function optionsIn(options) {
  return _lodash2.default.isNil(options) ? [] : [].concat(options);
}

function optionsOut(options, isMulti) {
  return isMulti ? options : _lodash2.default.first(options);
}

var Select = (0, _coreDecorators.autobind)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select(props) {
    var _ref2;

    (0, _classCallCheck3.default)(this, Select);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    /*
    | Note:
    |  Because Select reacts to so many event's, state change can be noisy.
    |  Controlling when state is updated can improve perceived performance.
    */
    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call.apply(_ref2, [this, props].concat(args)));

    _this.unmounted = false;
    _this.batchState = (0, _batch2.default)(function (nextState, cb) {
      return !_this.unmounted && _this.setState(nextState, cb);
    }, 5);
    _this.flushState = function (nextState, cb) {
      return _this.batchState.flush(nextState, cb);
    };

    _this.state = {
      filteredOptions: _this.filterOptions(''),
      inputValue: '',
      isOpen: false,
      index: 0,
      selectedOptions: optionsIn(props.selected)
    };
    _this.trackedInput = _this.state.inputValue;
    return _this;
  }

  (0, _createClass3.default)(Select, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return (0, _defineProperty3.default)({}, SELECT_MODEL, this.getModel());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if (this.props.selected !== next.selected) {
        this.receiveSelectedOptions(next.selected);
      }
      if (this.props.options !== next.options) {
        // HACK: We hold the value in object, instead of state, since updates to
        //       state might not be flushed current `this.state` object.
        this.flushState({
          filteredOptions: this.filterOptions(this.trackedInput, next)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Container = _props.Container,
          children = _props.children,
          options = _props.options,
          selected = _props.selected,
          multi = _props.multi,
          isLoading = _props.isLoading,
          ignoreAccents = _props.ignoreAccents,
          ignoreCase = _props.ignoreCase,
          filter = _props.filter,
          pluckLabel = _props.pluckLabel,
          pluckValue = _props.pluckValue,
          onSelect = _props.onSelect,
          props = (0, _objectWithoutProperties3.default)(_props, ['Container', 'children', 'options', 'selected', 'multi', 'isLoading', 'ignoreAccents', 'ignoreCase', 'filter', 'pluckLabel', 'pluckValue', 'onSelect']);

      return _react2.default.createElement(
        Container,
        props,
        children
      );
    }

    /*
    |-----------------------------------------------------------------------------
    | Model
    */

  }, {
    key: 'getModel',
    value: function getModel() {
      return {
        /*
        |-------------------------------------------------------------------------
        | State
        */
        state: {
          // Props
          optionsAll: this.props.options,
          multi: this.props.multi,
          isLoading: this.props.isLoading,

          // Managed
          options: this.state.filteredOptions,
          value: this.state.inputValue,
          selected: this.state.selectedOptions,
          index: this.state.index,
          isOpen: this.state.isOpen
        },

        /*
        |-------------------------------------------------------------------------
        | Actions
        */
        actions: {
          // Input Value
          setValue: this.setValue,
          clearValue: this.clearValue,

          // Selected Options
          pushIndexedToSelected: this.pushIndexedToSelected,
          pushSelected: this.pushSelected,
          popSelected: this.popSelected,
          clearSelected: this.clearSelected,

          // Menu
          openMenu: this.openMenu,
          closeMenu: this.closeMenu,
          setIndex: this.setIndex,
          incrementIndex: this.incrementIndex,
          decrementIndex: this.decrementIndex
        },

        /*
        |-------------------------------------------------------------------------
        | Helpers
        */
        helpers: {
          pluckLabel: this.props.pluckLabel,
          pluckValue: this.props.pluckValue
        }
      };
    }

    /*
    |-----------------------------------------------------------------------------
    | External Actions
    */

    /* Input Value */

  }, {
    key: 'setValue',
    value: function setValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.receiveInputValue(value);
    }
  }, {
    key: 'clearValue',
    value: function clearValue() {
      this.setValue('');
    }

    /* Selected */

  }, {
    key: 'pushIndexedToSelected',
    value: function pushIndexedToSelected() {
      var optionAtIndex = this.state.filteredOptions[this.state.index];
      this.pushSelected(optionAtIndex);
    }
  }, {
    key: 'pushSelected',
    value: function pushSelected(option) {
      if (option) {
        if (option.onSelect) {
          var event = createDumbEvent();
          option.onSelect(event);
          if (event.defaultPrevented) return;
        }
        this.selectOptions(this.props.multi ? this.state.selectedOptions.filter(function (o) {
          return o !== option;
        }).concat(option) : [option]);
      }
    }
  }, {
    key: 'popSelected',
    value: function popSelected() {
      this.selectOptions(this.state.selectedOptions.slice(0, -1));
    }
  }, {
    key: 'clearSelected',
    value: function clearSelected() {
      this.selectOptions([]);
    }

    /* Menu */

  }, {
    key: 'openMenu',
    value: function openMenu() {
      this.batchState({ isOpen: true });
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      this.batchState({ isOpen: false });
    }
  }, {
    key: 'setIndex',
    value: function setIndex(i) {
      if (this.state.index !== i) {
        this.flushState({ index: i });
      }
    }
  }, {
    key: 'incrementIndex',
    value: function incrementIndex() {
      this.shiftIndex(1);
    }
  }, {
    key: 'decrementIndex',
    value: function decrementIndex() {
      this.shiftIndex(-1);
    }

    /*
    |-----------------------------------------------------------------------------
    | Internal Management
    */

  }, {
    key: 'selectOptions',
    value: function selectOptions(options) {
      this.props.onSelect(optionsOut(options, this.props.multi));
    }
  }, {
    key: 'shiftIndex',
    value: function shiftIndex(direction) {
      var upper = this.state.filteredOptions.length;
      var current = this.state.index;
      var next = (current + direction) % upper;
      this.setIndex(next < 0 ? next + upper : next);
    }
  }, {
    key: 'receiveSelectedOptions',
    value: function receiveSelectedOptions(selectedOptions) {
      this.flushState({ selectedOptions: optionsIn(selectedOptions) });
    }
  }, {
    key: 'filterOptions',
    value: function filterOptions(inputValue) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

      var filterProps = {
        inputValue: inputValue,
        pluckLabel: props.pluckLabel,
        ignoreAccents: props.ignoreAccents,
        ignoreCase: props.ignoreCase
      };

      return props.filter(props.options, filterProps);
    }
  }, {
    key: 'receiveInputValue',
    value: function receiveInputValue(inputValue) {
      var filteredOptions = this.filterOptions(inputValue);
      // HACK: `this.state` updates may not be present in componentWillReceiveProps
      this.trackedInput = inputValue;
      this.flushState({
        inputValue: inputValue,
        filteredOptions: filteredOptions
      });
    }
  }]);
  return Select;
}(_react.Component), _class2.defaultProps = {
  Container: StyledContainer,
  options: [],
  selected: [],
  multi: false,
  isLoading: false,
  ignoreAccents: true,
  ignoreCase: true,
  filter: _defaultFilter2.default,
  pluckLabel: function pluckLabel(option) {
    return _lodash2.default.get(option, 'label');
  },
  pluckValue: function pluckValue(option) {
    return _lodash2.default.get(option, 'value');
  }
}, _class2.childContextTypes = (0, _defineProperty3.default)({}, SELECT_MODEL, _customPropTypes.SelectModelPropType), _temp)) || _class;

process.env.NODE_ENV !== "production" ? Select.propTypes = {
  /** Overridable Component */
  Container: _customPropTypes.ComponentPropType,
  children: _propTypes2.default.any.isRequired,
  /** Array of options: [{ value, label }] */
  options: _propTypes2.default.arrayOf(_customPropTypes.OptionPropType),
  /** A single option or an array of options */
  selected: _propTypes2.default.oneOfType([_customPropTypes.OptionPropType, _propTypes2.default.arrayOf(_customPropTypes.OptionPropType)]),
  /** Enables multi-value input (tags) */
  multi: _propTypes2.default.bool,
  /** Enables the LoadingIndicator, which indicates async option loading */
  isLoading: _propTypes2.default.bool,
  /** Whether to strip diacritics when filtering */
  ignoreAccents: _propTypes2.default.bool,
  /** Whether to perform case-insensitive filtering */
  ignoreCase: _propTypes2.default.bool,
  /** Called against all options with the user's input (option, term) */
  filter: _propTypes2.default.func,
  /** Gets the `label` from all given options */
  pluckLabel: _propTypes2.default.func,
  /** Gets the `value` from all given options */
  pluckValue: _propTypes2.default.func,
  /** Fires when option(s) are selected: function (newOptions) {} */
  onSelect: _propTypes2.default.func.isRequired
} : void 0;
exports.default = Select;